/**
 * Normaliza IDs de Test (PK Django, string alfanumérico de 9 chars) para
 * correct_tests_report/ y la sesión de corrección.
 */

function normalizeSingleTestId(value) {
  if (value == null || value === "") return null;

  if (typeof value === "number") {
    if (!isNaN(value) && value > 0) return String(value);
    return null;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return null;
    // Test.id en BaseModel: string alfanumérico (p. ej. "A1B2C3D4E")
    if (/^[A-Za-z0-9]{1,20}$/.test(trimmed)) return trimmed;
    const parsed = parseInt(trimmed, 10);
    if (!isNaN(parsed) && parsed > 0 && String(parsed) === trimmed) {
      return trimmed;
    }
  }

  return null;
}

export function normalizeTestIds(raw) {
  if (raw == null) return [];
  const list = Array.isArray(raw) ? raw : [raw];
  const ids = [];
  for (let i = 0; i < list.length; i += 1) {
    const value = list[i];
    let candidate = value;
    if (value && typeof value === "object") {
      candidate = value.id || value.test_record_id || value.testRecordId;
    }
    const normalized = normalizeSingleTestId(candidate);
    if (normalized && ids.indexOf(normalized) === -1) {
      ids.push(normalized);
    }
  }
  return ids;
}

export function extractTestRecordId(result) {
  if (!result || typeof result !== "object") return null;

  const candidates = [
    result.id,
    result.test_record_id,
    result.testRecordId,
  ];

  for (let i = 0; i < candidates.length; i += 1) {
    const normalized = normalizeSingleTestId(candidates[i]);
    if (normalized) return normalized;
  }

  if (result.data && typeof result.data === "object") {
    const nested = normalizeSingleTestId(result.data.id);
    if (nested) return nested;
  }

  return null;
}
